import { BranchStep } from '../../../dorian-shared/types/branch/BranchStep';
import { CursorPosition } from '../../../contexts/Cursor/cursorReducer';
import { NodeGetter } from './getNode';
import { FEATURE_NODE_EDIT_SIDE_PANEL } from '../../../helpers/featureFlags';

export function useStepAtCursor(
  cursor: CursorPosition | null,
  nodeGetter: NodeGetter,
): BranchStep | null {
  if (!FEATURE_NODE_EDIT_SIDE_PANEL) return null;
  if (!cursor || cursor.stepIndex === null) return null;
  const node = nodeGetter(cursor.branchId);
  if (!node?.steps) return null;
  return node.steps[cursor.stepIndex] ?? null;
}
